import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__brand">
          <img src={logo} alt="OLYMPUS MEDS" className="footer__logo" />
          <div className="footer__tag">Pharmaceutical-grade formulations · Berlin, Germany</div>
        </div>
        <div className="footer__cols">
          <div className="footer__col">
            <div className="footer__heading">Navigate</div>
            <Link to="/">Home</Link>
            <Link to="/catalog">Catalog</Link>
            <Link to="/about">About</Link>
          </div>
          <div className="footer__col">
            <div className="footer__heading">Origin</div>
            <span>Berlin · Germany</span>
            <span>EU-sourced actives</span>
            <span>Sterile manufacturing</span>
          </div>
          <div className="footer__col">
            <div className="footer__heading">Notice</div>
            <span>Showcase only</span>
            <span>Not for sale</span>
            <span>Research reference</span>
          </div>
        </div>
      </div>
      <div className="footer__bottom">
        <span>© {year} OLYMPUS MEDS</span>
        <span className="footer__motto">Pharmaceutical-grade · Berlin</span>
      </div>
    </footer>
  );
}
